import React from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { RichTextEditor, TextBox, CheckBox, DatePicker } from 'fw/forms';
import { SetupTab } from 'areas/shared/pages/setup';
import { Label } from 'fw/components';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Formatting from 'fw/misc/Formatting'

class NewsInfoTab extends SetupTab {
    initialForm() {
        return { 
            content: "",
            description: "",
            active: true,
            startDate: Formatting.formatToday(),
            endDate: null,
            rowVersion: null
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege("AdminNewsSetupAdd"),
            edit: App.hasPrivilege("AdminNewsSetupEdit")
        }
    }

    urls() {
        return {
            get: API.App.url('/newsSetup/getNewsInfo'),
            save: API.App.url('/newsSetup/saveNewsInfo'),
            create: API.App.url('/newsSetup/createNews')
        }
    }

    getRequest(selectedId) {
        return {
            newsId: selectedId
        }
    }

    saveRequest() {
        return {
            newsId: this.props.selectedId,
            content: this.state.form.content,
            description: this.state.form.description,
            active: this.state.form.active,
            startDate: this.state.form.startDate,
            endDate: this.state.form.endDate,
            rowVersion: this.state.form.rowVersion
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label htmlFor="description" required>News Title</Label>
                            <TextBox 
                                name="description" 
                                placeholder="News Title"
                                maxLength={128} 
                                required 
                                ref={(c) => { this.focusControl = c; }} />                                    
                            <CheckBox name="active" label="Active" />
                        </FormGroup>
                    </Col>                                 
                    <Col md={3}>
                        <FormGroup>                    
							<Label>Publish start date</Label><br />
                            <DatePicker 
                                name="startDate" 
                                placeholder="Start Date..."
                                showTime={false} />
                            <Label>Publish end date</Label><br />
                            <DatePicker 
                                name="endDate" 
                                placeholder="End date..." 
                                showTime={false}/>                            
                        </FormGroup>
				    </Col>  
                </Row>
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <RichTextEditor enabled={this.state.enabled} name="content" />
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default NewsInfoTab; 



// WEBPACK FOOTER //
// ./src/areas/admin/newsSetup/newsInfo/NewsInfoTab.js